import { Module } from 'wrapper6'

const $ = jQuery

export default class SmoothScroll extends Module {
  ready () {
    $('a[href^="#"]').click((e) => {
      e.preventDefault()

      const id = this.getIdFromHref(e.target)
      const el = document.getElementById(id)

      if (el) {
        $('html, body').animate({
          scrollTop: $(`#${id}`).offset().top - 100
        }, 500)

        this.openTabIfTabEl(el)
      }
    })
  }

  getIdFromHref (href) {
    let id = null

    if (href) {
      id = $(href).attr('href')
      id = id.replace('#', '')
    }

    return id
  }

  openTabIfTabEl (el) {
    if (el.classList.contains('mtt-tabs-widget__tab')) {
      el.click()
    }
  }
}
